import { UsersAPI } from '@/apis/users.api';
import { IUser } from '@/models/IUser.model';

export default async function SignUpHelper(user: IUser) {
     const userAPI = new UsersAPI();
     await userAPI.post(user);
     return user;
}